import React from 'react';
import useStyles from './styles';
import visibilityTotal from '../../../assets/images/visibilidad_total.svg'
import AdminUser from '../../../assets/images/admin-user.svg'
import CampaignOptimization from '../../../assets/images/campaign-optimization.svg'
import DocumentExtract from '../../../assets/images/document-extract.svg'
import AutomaticSettlement from '../../../assets/images/automatic-settlement.svg'
import Carousel from './Carousel';

interface CarouselProps {
  image: string;
  title: string;
  desc: string
}

const TakeControlContent: React.FC = () => {
  const classes = useStyles();

  const slideItems: CarouselProps[] = [
    {
      image: AdminUser,
      title: 'Administración de usuarios',
      desc: 'Organiza tus equipos por negocio, marca o región, con privacidad garantizada.'
    },
    {
      image: visibilityTotal,
      title: 'Tablero de gestión presupuestal',
      desc: 'Obtén indicadores en tiempo real.'
    },
    {
      image: CampaignOptimization,
      title: 'Optimización de campañas',
      desc: 'Gestiona tus campañas con briefs, presupuesto, cambios y consumo en un solo lugar.'
    },
    {
      image: AutomaticSettlement,
      title: 'Conciliación automatizada',
      desc: 'Obtén reportes a tu medida.'
    },
    {
      image: DocumentExtract,
      title: 'Extracción de información en múltiples formatos',
      desc: 'Transforma tus datos en formatos flexibles.'
    }
  ]

  return (
    <section id="acerca-de" className={classes.section}>
      <div className={classes.textContainer}>
        <h2 className={classes.heading}>Toma el control de tu publicidad</h2>
        <Carousel items={slideItems} />
      </div>
    </section>
  );
};

export default TakeControlContent;